module.exports = __webpack_public_path__ + "img/gc_country_flag_cz.d12a3224.svg";